export enum UiBreakpoints {
  XS = '(max-width: 639px)',
  SM = '(max-width: 767px)',
  MD = '(max-width: 1023px)',
  LG = '(max-width: 1279px)',
  XL = '(max-width: 1535px)',
  XXL = '(min-width: 1536px)',
}
